export default "__VITE_ASSET__mj2hqPPo__"